import type { IDockviewPanelProps } from 'dockview';
import {
  DEFAULT_MULTILEG_PRICE_BLOTTER_COLUMNS,
  DEFAULT_MULTILEG_PRICE_BLOTTER_FILTER,
  PriceBlotter,
} from '../../../../containers/Blotters/PriceBlotter';
import type { PriceGridPanelConfig } from '../../../../types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';

export function MultilegPriceGridPanel({ api }: IDockviewPanelProps<PriceGridPanelConfig>) {
  return (
    <Panel panelApi={api} data-testid="multileg-price-grid-panel">
      <PriceBlotter
        blotterID={api.id}
        defaultColumns={DEFAULT_MULTILEG_PRICE_BLOTTER_COLUMNS}
        defaultFilter={DEFAULT_MULTILEG_PRICE_BLOTTER_FILTER}
      />
    </Panel>
  );
}
